module.exports = __webpack_public_path__ + "media/images/iocon-arrow-down-d667d62c7b09865b207e610a252d0fd1.svg";